export default __webpack_public_path__ + "static/media/smiling-man.32c62615.svg";